/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The platform of the meeting (zoom, meet, or teams)
 */
export type ListBotsResponseDataItemMeetingPlatform =
  (typeof ListBotsResponseDataItemMeetingPlatform)[keyof typeof ListBotsResponseDataItemMeetingPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListBotsResponseDataItemMeetingPlatform = {
  zoom: "zoom",
  meet: "meet",
  teams: "teams"
} as const
